<script setup lang="ts">
import OrderManagement from "@/views/playground/planner/order-management/OrderManagement.vue";
</script>

<template>
  <order-management></order-management>
</template>

<style scoped></style>
